import { createContext } from 'react'

/**
 * Spec 171 — opt-in for the per-column filter's match mode, for a ColumnValuePicker
 * that its HOST does not render.
 *
 * The flat report grid's filter row is drawn by the shared DataGrid
 * (`ColumnFilterCell`), which hands ColumnValuePicker exactly four props and is
 * also the grid for 12 other callers (Matters, Invoices, Payments, … and the
 * Report Queue's two tables, counted 2026-10-13). Those filter with TanStack's
 * `includesString`, which stringifies an object value to "[object Object]" and
 * empties the grid, so they must never receive `{ text, mode }` — and DataGrid is
 * not this change's file. So ReportDataGrid provides this context AROUND
 * DataGrid instead of DataGrid passing a prop: the report grids opt in, and every
 * DataGrid with no provider above it reads the default `null` and is unchanged.
 *
 * The grouped grid renders ColumnValuePicker itself and opts in with the
 * `matchModes` prop; a prop on the picker always wins over this context.
 *
 * Value: `null` (off) or `{ enabled: true, resetKey }`. `resetKey` changes when
 * the host resets its grid layout ("Reset grid layout"), which clears every
 * column filter — the operator a user chose goes back to Contains with it, so a
 * reset grid is never left anchoring the next thing typed.
 */
export const ColumnFilterMatchModeContext = createContext(null)
